import { api } from '@/lib/axios';

export interface DashboardStatistics {
  overview: {
    totalClients: number;
    activeClients: number;
    totalCompanies: number;
    totalLists: number;
    totalEmailTemplates: number;
    activeEmailTemplates: number;
    totalTags: number;
    totalPositions: number;
  };
  orders: {
    total: number;
    totalValue: number;
    averageTicket: number;
  };
  flows: {
    totalExecutions: number;
  };
  growth: {
    clients: GrowthData;
    companies: GrowthData;
    lists: GrowthData;
  };
  listMembers: {
    total: number;
    manual: number;
    filter: number;
  };
  topCompanies: Array<{
    id: string;
    name: string;
    employeesCount: number;
  }>;
  topProducts: Array<{
    id: string;
    name: string;
    price: number;
    quantitySold: number;
    orderCount: number;
    image: string | null;
  }>;
  recent: {
    clients: Array<{
      id: string;
      name: string;
      email?: string;
      createdAt: string;
    }>;
    companies: Array<{
      id: string;
      name: string;
      cnpj?: string;
      createdAt: string;
    }>;
    activities: Array<{
      id: string;
      type: 'order' | 'flow' | 'event';
      description: string;
      metadata: any;
      createdAt: string;
    }>;
  };
  upcomingBirthdays: Array<{
    id: string;
    name: string;
    email?: string;
    phone?: string;
    birthDate: string;
    daysUntilBirthday: number;
    birthdayThisYear: string;
  }>;
}

export interface GrowthData {
  current: number;
  previous: number;
  rate: number;
}

export interface ChartData {
  clients: Array<{ date: string; count: number }>;
  companies: Array<{ date: string; count: number }>;
  lists: Array<{ date: string; count: number }>;
}

export interface FlowExecutionsByStatus {
  status: string;
  count: number;
}

export const dashboardService = {
  async getStatistics(params?: {
    startDate?: string;
    endDate?: string;
  }): Promise<DashboardStatistics> {
    const { data } = await api.get('/dashboard/statistics', { params });
    return data;
  },

  async getChartData(params?: {
    startDate?: string;
    endDate?: string;
  }): Promise<ChartData> {
    const { data } = await api.get('/dashboard/charts', { params });
    return data;
  },

  async getFlowExecutionsByStatus(): Promise<FlowExecutionsByStatus[]> {
    const { data } = await api.get('/dashboard/flow-executions-by-status');
    return data;
  },
};
